import { Component, Input } from '@angular/core';

import { AppContext } from './../shared';

@Component({
  selector: 'message',
  template: require('./message.component.html'),
  styles: [require('./message.component.scss')]
})

export class MessageComponent {
  @Input() title: string;
  @Input() content: string;

  constructor(private app: AppContext) {
    // Do stuff
  }

  close() {
    this.app.hideMessage();
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/message/message.component.ts